import { accountService } from '@libs/data-access/queries'

const usePadSettings = () => {
  const accountQuery = accountService.useFetchCurrent({})

  const hasSnapPad = accountQuery.data?.uses_timeclock
  const padType =
    accountQuery.data?.timeclock_preferences?.break_filling_method ||
    'break_event'
  const hasSnapPadBreaksEnable =
    accountQuery.data?.timeclock_preferences?.has_break_enabled || false
  const hasSnapPadMealEnable =
    accountQuery.data?.timeclock_preferences?.allow_filling_meal || false
  const breakAsReal =
    accountQuery.data?.timeclock_preferences
      ?.use_break_time_as_real_break_hour || false

  return {
    hasSnapPad,
    padType,
    hasSnapPadBreaksEnable,
    hasSnapPadMealEnable,
    breakAsReal
  }
}

export default usePadSettings
